import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {SidePanel, UploadDropzone, UploadFooterView, UploadHeaderView} from 'front-onceforall-core';

export const UploadFileView = props => (
  <SidePanel onClose={props.onClose}>
    <form onSubmit={props.onSubmit}>
      <div className="col-12">
        <UploadHeaderView
          documentName={props.documentName}
        />
        <div className="mt-5">
          <UploadDropzone
            extensions={props.extensions}
            onDrop={props.onFileSelection}
            maxSize={props.fileMaxSize}
            minSize={props.fileMinSize}
            errorFileMessage={props.errorMessage}
          />
          {props.filename &&
            <div className="information mt-4">
              <Translate value="document.filename"/>: <strong>{props.filename}</strong>
            </div>
          }
          <UploadFooterView
            isSubmittable={props.submittable}
            submitted={props.submitted}
            onCancelClick={props.onClose}
          />
        </div>
      </div>
    </form>
  </SidePanel>
);

UploadFileView.propTypes = {
  // Title of doc in header
  documentName: PropTypes.string.isRequired,
  filename: PropTypes.string,
  extensions: PropTypes.string.isRequired,
  fileMaxSize: PropTypes.number.isRequired,
  fileMinSize: PropTypes.number.isRequired,
  // JSX object allowed
  errorMessage: PropTypes.object,
  submittable: PropTypes.bool.isRequired,
  submitted: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onFileSelection: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default UploadFileView;
